function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ANIMATION_TIMEOUT } from "@config/constants";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import Paper from "@material-ui/core/Paper";
import { isNil } from "lodash";
import React from "react";
import { connect } from "react-redux";
var EditForm = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(EditForm, _React_Component);
    var _super = _create_super(EditForm);
    function EditForm(props) {
        _class_call_check(this, EditForm);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "toggleEdit", function(state) {
            var editting = _this.state.editting;
            _this.setState({
                expanded: false
            });
            setTimeout(function() {
                _this.setState({
                    expanded: true,
                    editting: isNil(state) ? !editting : state
                });
            }, ANIMATION_TIMEOUT);
        });
        _define_property(_assert_this_initialized(_this), "renderReadView", function() {
            var readView = _this.props.readView;
            return /*#__PURE__*/ _jsx("div", {
                className: "item-wrapper",
                children: readView
            });
        });
        _define_property(_assert_this_initialized(_this), "renderEditView", function() {
            var editView = _this.props.editView;
            return /*#__PURE__*/ _jsx("div", {
                style: {
                    justifyContent: "center",
                    marginLeft: 8,
                    marginRight: 8
                },
                children: editView
            });
        });
        _define_property(_assert_this_initialized(_this), "renderCardBody", function() {
            return _this.state.editting ? _this.renderEditView() : _this.renderReadView();
        });
        _define_property(_assert_this_initialized(_this), "renderEditButton", function() {
            var _this_props = _this.props, i18n = _this_props.i18n, changeButtonName = _this_props.changeButtonName;
            if (_this.state.editting) return null;
            return /*#__PURE__*/ _jsx(Button, {
                fullWidth: true,
                className: "border-wrapper",
                size: "large",
                style: {
                    fontSize: "1.2rem"
                },
                onClick: function() {
                    return _this.toggleEdit();
                },
                children: changeButtonName || i18n.settings.change
            });
        });
        _this.state = {
            expanded: true,
            editting: _this.props.editting
        };
        return _this;
    }
    _create_class(EditForm, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.editting !== prevProps.editting && this.props.editting !== this.state.editting) {
                    this.toggleEdit(this.props.editting);
                }
                if (this.state.editting !== prevState.editting) {
                    var onEditChange = this.props.onEditChange;
                    onEditChange && onEditChange(this.state.editting);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, title = _this_props.title, iconClassName = _this_props.iconClassName;
                return /*#__PURE__*/ _jsxs(Collapse, {
                    in: this.state.expanded,
                    timeout: ANIMATION_TIMEOUT,
                    className: "edit-information-margin",
                    children: [
                        /*#__PURE__*/ _jsxs(Paper, {
                            square: true,
                            className: "edit-information-wrapper light edit-information-collapsable",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "head",
                                    children: [
                                        iconClassName && /*#__PURE__*/ _jsx("span", {
                                            className: iconClassName
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text",
                                            children: title
                                        })
                                    ]
                                }),
                                this.renderCardBody()
                            ]
                        }),
                        this.renderEditButton()
                    ]
                });
            }
        }
    ]);
    return EditForm;
}(React.Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n;
    return {
        i18n: i18n
    };
};
export default connect(mapStateToProps)(EditForm);
